"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'FAB require that you use the <code class="inline">iconName</code> ' +
    'property. By default it has a redish background and a white color for the icon.';
var code = "import React from 'react';\nimport { FAB } from 'jsc-react-ui';\n\nconst Example = () => <FAB iconName=\"plus\" />;";
exports.SimpleExampleFAB = function () { return (React.createElement(common_1.Example, { title: "Simple", description: description, code: code },
    React.createElement(components_1.FAB, { iconName: "plus" }))); };
exports.SimpleExampleFAB.displayName = 'SimpleExampleFAB';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentFABPage/SimpleExampleFAB.tsx
// module id = 669
// module chunks = 0